var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAttention(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attention-/-yellow-/-icon_attention",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_attention"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Attention-(filled)",
    transform: "translate(1.000000, 1.000000)",
    fill: "#F4D811",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9710526,0 C4.91190757,-3.7101563e-16 -1.34688235e-14,4.91190757 -1.42108547e-14,10.9710526 C-1.4952886e-14,17.0301977 4.91190757,21.9421053 10.9710526,21.9421053 C17.0301977,21.9421053 21.9421053,17.0301977 21.9421053,10.9710526 C21.9346621,4.91499331 17.027112,0.00744315043 10.9710526,0 Z M10.295614,6.85280702 C10.295614,6.47977258 10.5980182,6.17736842 10.9710526,6.17736842 C11.3440871,6.17736842 11.6464912,6.47977258 11.6464912,6.85280702 L11.6464912,10.9710526 C11.6464912,11.3440871 11.3440871,11.6464912 10.9710526,11.6464912 C10.5980182,11.6464912 10.295614,11.3440871 10.295614,10.9710526 L10.295614,6.85280702 Z M10.9710526,15.9654386 C10.488491,15.9654374 10.0971988,15.5744315 10.0968445,15.0918699 C10.0964902,14.6093084 10.4872078,14.2177283 10.9697689,14.2170185 C11.4523301,14.2163087 11.8441979,14.6067378 11.8452632,15.0892982 C11.8431584,15.5715509 11.4532995,15.9622704 10.9710526,15.9654386 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttention);
export default __webpack_public_path__ + "static/media/icon_attention.a30edb4f9e69c6ddd5f50f9e78d7c333.svg";
export { ForwardRef as ReactComponent };